var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"form-message"}},[(_vm.message != null)?_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_c('span',{staticClass:"glyphicon glyphicon-info-sign",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.message)+"\n    ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f2f2542","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FormMessage.vue
// module id = /ljc
// module chunks = 15